import { withStylePrefix } from '../common/withStylePrefix';
import { ProgressStepperComponent, progressStepperTemplate } from './ProgressStepper';
import styles from './ProgressStepper.styles.scss';
export const progressStepperDefinition = {
    baseName: 'progress-stepper',
    template: progressStepperTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonProgressStepper = ProgressStepperComponent.compose(progressStepperDefinition);
